export default {
    projects(state) {
        return state.projects
    }
}
